import React from 'react';

import { Route } from 'react-router-dom';

const RouteWithCode = ({ code, children, ...rest }) => {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext && code) {
          staticContext.statusCode = code;
        }

        return children;
      }}
      {...rest}
    />
  );
};

export default RouteWithCode;
